<template>
  <div class="evaluation-index-container" :class="slotId !== 'main' ? 'd-flex flex-nowrap overflow-auto w-100' : '' ">
    <Transition name="slide-left-right">
      <div v-if="!showEvaluationForm && !showFormEmailPreview" class="w-100">
        <b-row v-if="showFilters" class="pt-2 pb-1">
          <b-col cols="6" class="d-flex align-items-center">
            <BreadcrumbMenu />
          </b-col>
          <b-col cols="6" class="pr-3 text-right">
            <button-filters
              @show-modal="$root.$emit('bv::show::modal', $event)"
              :filters-count="filtersCount"
              @clear-search-filters="clearSearchFilters"
            />
          </b-col>
        </b-row>

        <!-- Filters -->
        <filter-modal
          v-if="showFilters"
          @action="buildFilters()"
          @clear="clearSearchFilters()"
        >
          <template v-slot:main-filters>
            <filters
              :filters-count="filtersCount"
              :template-filter.sync="templateFilter"
              :template-options="templateOptions"
              :is-template-filter-disabled="isBauComplementsMode"
              :show-bau-extra-filters="isBauComplementsMode"
              :sector-filter.sync="sectorFilter"
              :region-filter.sync="regionFilter"
              :unit-filter.sync="unitFilter"
              :unit-options="unitOptions"
              :user-filter.sync="userFilter"
              :user-options="userOptions"
              :status-filter.sync="statusFilter"
              :status-options="statusOptions"
              :from-filter.sync="fromFilter"
              :to-filter.sync="toFilter"
            />
          </template>
        </filter-modal>

        <b-card :class="{ 'mx-2 my-1 box-shadow-unset': showFilters }" no-body>
          <div class="m-2">
            <b-row>
              <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                v-if="showFilters"
              >
                <label class="text-capitalize">{{ $t("table.show") }}</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label class="text-capitalize">{{ $t("table.entries") }}</label>
              </b-col>

              <b-col cols="12" :md="showFilters ? 6 : 12">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    :class="{ 'form-control-sm': !showFilters }"
                    :placeholder="$t('table.search')"
                  />

                  <!-- Filter button for slot mode -->
                  <b-button-group v-if="!showFilters" class="mr-1">
                    <b-button
                      @click="isFilterPanelOpen = true"
                      class="buttonFilter cursor-pointer d-flex align-items-center"
                      data-cy="filter-btn"
                    >
                      <b-icon-filter-circle-fill scale="1.1" />
                      <span class="align-middle ml-1 text-capitalize">{{
                        $t("filters")
                      }}</span>
                    </b-button>
                    <toggle-clear-filter
                      @clear-search-filters="clearSearchFilters()"
                      :filters-count="filtersCount"
                    />
                  </b-button-group>

                  <b-button
                    type="button"
                    variant="success"
                    class="text-capitalize mr-1"
                    :class="{ 'buttonFilter px-1': !showFilters }"
                    :disabled="dataMeta.from === 0"
                    @click="checkExport()"
                  >
                    <feather-icon icon="DownloadCloudIcon" size="15" />
                  </b-button>
                  <b-button
                    v-if="!isBauComplementsMode && $can('bulk_form_upload', 'OpSecurityFormAnswers')"
                    type="button"
                    variant="info"
                    class="text-capitalize mr-1"
                    :class="{ 'buttonFilter px-1': !showFilters }"
                    v-b-tooltip.hover
                    :title="$t('messages.import.title')"
                    v-b-modal.import_file
                  >
                    <feather-icon icon="UploadCloudIcon" size="15" />
                  </b-button>
                  <b-button
                    v-if="!isBauComplementsMode && $can('task_creation', 'OpSecurityFormAnswers')"
                    variant="primary"
                    class="text-capitalize mr-1 d-inline-flex align-items-center"
                    :class="{ 'buttonFilter px-1': !showFilters }"
                    type="button"
                    v-b-tooltip.hover
                    :title="$t('unit.assign_task')"
                    @click="openAssignTaskModalFromToolbar"
                  >
                    <feather-icon icon="CheckSquareIcon" size="15" />
                  </b-button>
                  <b-button
                    variant="primary"
                    class="d-inline-flex align-items-center"
                    :class="{ 'buttonFilter px-1': !showFilters }"
                    @click="openEvaluationModalWithContext"
                    v-if="$can('create', 'OpSecurityFormAnswers')"
                  >
                    <span v-if="showFilters" class="text-nowrap text-capitalize">
                      {{
                        `${$t("actions.add")} ${$tc(
                          "operational_security.evaluation.title",
                          1
                        )}`
                      }}
                    </span>
                    <feather-icon v-else icon="PlusCircleIcon" size="16" />
                  </b-button>
                </div>
              </b-col>
              <!-- <b-col cols="12" v-if="!showFilters" class="mt-2">
                <FiltersRow
                  :template-filter.sync="templateFilter"
                  :template-options="templateOptions"
                  :unit-filter.sync="unitFilter"
                  :unit-options="unitOptions"
                  :user-filter.sync="userFilter"
                  :user-options="userOptions"
                  :status-filter.sync="statusFilter"
                  :status-options="statusOptions"
                />
              </b-col> -->
            </b-row>
          </div>
          <div
            :class="{ 'custom-sticky-wrapper': !showFilters }"
            :style="!showFilters ? 'max-height: 500px; display: block;' : ''"
          >
            <b-table
              ref="refListTable"
              class="position-relative"
              :items="fetchList"
              :fields="tableColumns"
              primary-key="id"
              :sort-by.sync="sortBy"
              show-empty
              :empty-text="$t('no_record_found')"
              :sort-desc.sync="isSortDirDesc"
              @row-clicked="openEditEvaluationModal"
            >
              <template #head()="data">
                <span> {{ $tc(data.label, 1) }}</span>
              </template>

              <template #head(actions)="data">
                <span> {{ $tc(data.label, 2) }}</span>
              </template>

              <template #cell(ref)="data">
                <p
                  class="mb-0"
                  v-b-tooltip.right.hover
                  :title="
                    data.item.externalFields ? data.item.externalFields.descripcion : ''
                  "
                  style="width: fit-content"
                >
                  {{ data.item.ref || data.item.reference }}
                </p>
                <b-badge :variant="getStatusVariant(data.item.status)">
                  {{ getStatusLabel(data.item.status) }}
                </b-badge>
              </template>

              <template #cell(related_forms)="data">
                <p v-for="form in data.item.related_forms">
                  <b-badge variant="info" class="badge-inline">
                    <span>{{ form.template }}</span>
                    <b-badge pill style="margin-left: 4px">
                      <span>{{ form.count }}</span>
                    </b-badge>
                  </b-badge>
                </p>
              </template>

              <template #cell(id_template)="data">
                <span v-if="data.item.template"> {{ data.item.template.name }}</span>
              </template>

              <template #cell(name_unit)="data">
                <span>{{ data.item ? data.item.name_unit || "" : "" }}</span>
              </template>

              <template #cell(id_unit)="data">
                <span>
                  {{
                    data.item && data.item.unit ? data.item.unit.description : ""
                  }}</span
                >
              </template>

              <template #cell(user)="data">
                <p class="mb-0">
                  {{ data.item.owner ? data.item.owner.full_name : "" }}
                </p>
                <small>{{ data.item.owner ? data.item.owner.user : "" }} </small>
              </template>

              <template #cell(status)="data">
                <b-badge
                  v-if="data.item.status"
                  :variant="getStatusVariant(data.item.status)"
                >
                  {{ getStatusLabel(data.item.status) }}
                </b-badge>
                <span v-else class="text-muted">-</span>
              </template>

              <template #cell(actions)="data">
                <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>

                  <b-dropdown-item
                    v-if="$can('update', 'OpSecurityFormAnswers')"
                    @click="openEditEvaluationModal(data.item)"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50 text-capitalize">
                      {{ $t("actions.edit") }}
                    </span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="!isBauComplementsMode && $can('task_creation', 'OpSecurityFormAnswers')"
                    @click="openAssignTaskModal(data.item)"
                  >
                    <feather-icon icon="CheckSquareIcon" />
                    <span class="align-middle ml-50 text-capitalize">
                      {{ $t("unit.assign_task") }}
                    </span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="!isBauComplementsMode || data.item.status === 'completed'"
                    @click="donwloadPdf(data.item)"
                  >
                    <feather-icon icon="FileIcon" />
                    <span class="align-middle ml-50 text-capitalize">
                      {{ $t("messages.export.download") }} PDF
                    </span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="!isBauComplementsMode || $can('create', 'OpSecurityFormAnswers')"
                    v-for="related in relatedTemplates(data.item)"
                    :key="related.id + 'related'"
                    @click="openCreateNewFormType(data.item, related)"
                  >
                    <feather-icon icon="FilePlusIcon" />
                    <span class="align-middle ml-50 text-capitalize">
                      {{ $t("operational_security.evaluation.create") }}
                      {{ related.name }}
                    </span>
                  </b-dropdown-item>

                  <template
                    v-if="
                      data.item.is_sitrep &&
                      data.item.template &&
                      data.item.template.is_mailable &&
                      $can('approve', 'OpSecurityFormAnswers')
                    "
                  >
                    <!-- Email Preview -->
                    <b-dropdown-item @click="openFormEmailPreview(data.item)">
                      <feather-icon icon="EyeIcon" />
                      <span class="align-middle ml-50 text-capitalize">
                        {{ $t("operational_security.evaluation.email_preview") }}
                      </span>
                    </b-dropdown-item>
                  </template>
                  <template
                    v-else-if="
                      !data.item.is_sitrep &&
                      data.item.template &&
                      data.item.template.is_mailable
                    "
                  >
                    <!-- Email Preview -->
                    <b-dropdown-item @click="openFormEmailPreview(data.item)">
                      <feather-icon icon="EyeIcon" />
                      <span class="align-middle ml-50 text-capitalize">
                        {{ $t("operational_security.evaluation.email_preview") }}
                      </span>
                    </b-dropdown-item>
                  </template>

                  <b-dropdown-item
                    v-if="
                      isBauComplementsMode &&
                      isInProgressStatus(data.item) &&
                      $can('delete', 'BauComplement')
                    "
                    @click="confirmDeleteBauComplement(data.item)"
                  >
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50 text-capitalize">
                      {{ $t("actions.delete") }}
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span class="text-muted text-capitalize">{{
                    $t("table.showing", {
                      from: dataMeta.from,
                      to: dataMeta.to,
                      of: dataMeta.of,
                    })
                  }}</span>
                </b-col>

                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <Pagination
                    :totalList="totalList"
                    :currentPage="currentPage"
                    @updatePagination="updatePagination"
                    :perPage="perPage"
                  >
                  </Pagination>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>

        <assign-task-modal
          modal-id="assign-task-form-modal"
          task-type-context="form"
          :initial-task-type="selectedFormAnswerForTask ? 'answered-form' : null"
          :unit-options="unitOptions"
          :form-answer-id="
            selectedFormAnswerForTask ? selectedFormAnswerForTask.id : null
          "
          :form-answer-options="formTemplateOptionsForAssignTask"
          :form-answer-reference="
            selectedFormAnswerForTask
              ? selectedFormAnswerForTask.reference || selectedFormAnswerForTask.ref
              : null
          "
          :form-answer-template-id="
            selectedFormAnswerForTask && selectedFormAnswerForTask.template
              ? selectedFormAnswerForTask.template.id
              : null
          "
          :form-answer-template-name="
            selectedFormAnswerForTask && selectedFormAnswerForTask.template
              ? selectedFormAnswerForTask.template.name
              : null
          "
          :form-answer-template="
            selectedFormAnswerForTask && selectedFormAnswerForTask.template
              ? selectedFormAnswerForTask.template
              : null
          "
          :user-options="userOptions"
          :fetch-users="fetchUsers"
          @task-assigned="handleTaskAssigned"
          @refetch-data="refetchData"
        />
      </div>
    </Transition>

    <!-- Filters Panel Fullscreen for slot mode -->
    <Transition name="slide-right-left">
      <div v-if="!showFilters && isFilterPanelOpen" class="filters-panel-fullscreen">
        <div class="filters-panel-header">
          <p class="h4 text-capitalize mb-2 text-white">
            {{ $t("messages.info.advanced_search") }}
          </p>
          <b-button
            variant="link"
            size="sm"
            @click="isFilterPanelOpen = false"
            class="text-dark p-0"
          >
            <feather-icon icon="XIcon" size="24" />
          </b-button>
        </div>
        <div class="filters-panel-content">
          <filters
            :template-filter.sync="templateFilter"
            :template-options="templateOptions"
            :is-template-filter-disabled="isBauComplementsMode"
            :show-bau-extra-filters="isBauComplementsMode"
            :sector-filter.sync="sectorFilter"
            :region-filter.sync="regionFilter"
            :unit-filter.sync="unitFilter"
            :unit-options="unitOptions"
            :user-filter.sync="userFilter"
            :user-options="userOptions"
            :status-filter.sync="statusFilter"
            :status-options="statusOptions"
            :from-filter.sync="fromFilter"
            :to-filter.sync="toFilter"
          />
        </div>
        <div class="filters-panel-footer">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="clearSearchFilters()"
            class="text-capitalize"
          >
            {{ $t("messages.info.clear_filters") }}
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            @click="applyFilters()"
            class="text-capitalize"
          >
            {{ $t("search") }}
            <feather-icon icon="SearchIcon" />
          </b-button>
        </div>
      </div>
    </Transition>

    <Transition name="slide-right-left">
      <div class="p-1 w-100" v-if="showEvaluationForm">
        <div class="mx-2">
          <h5 class="my-1" v-if="isCreateRegistration">
            {{ $t("operational_security.evaluation.new_evaluation") }}
          </h5>
          <h5 class="my-1" v-else-if="currentEvaluationId">
            {{ $t("operational_security.evaluation.edit_evaluation") }}
          </h5>
          <h5 class="my-1" v-if="currentSpecialForm">
            {{ $t("operational_security.evaluation.create") }} {{ currentSpecialForm }}
          </h5>
          <EvaluationForm
            :show-back-button="true"
            :evaluationId="currentEvaluationId"
            :evaluation="currentEvaluation"
            :isCreate="!currentEvaluationId"
            :isCreateRegistration="isCreateRegistration"
            :isCreateSpecialForms="isCreateSpecialForms"
            :currentSpecialForms="currentSpecialForm"
            :idFormAnswerOwner="idFormAnswerOwner"
            :dataToReplace="currentDataToReplace"
            :openFromUrlParam="openFromUrlParam"
            :currentUrlParam="currentUrlParam"
            :initial-template-id="startFormTemplateIdRef"
            :isPrefill="requiresPrefillRef"
            :initialUnit="initialUnitRef"
            @navigate-to-form="handleNavigateToForm"
            @openCreateNewFormType="openCreateNewFormType"
            @go-back-to-list="goBackToList()"
          />
        </div>
      </div>
    </Transition>

    <Transition name="slide-right-left">
      <div :class="showFilters ? 'p-1' : 'py-1 px-0'" v-if="showFormEmailPreview">
        <div
          class="d-flex justify-content align-items-center mb-1 cursor-pointer mx-2"
          @click="goBackToList()"
        >
          <button
            class="btn btn-sm rounded-circle p-25"
            :class="isDark ? 'btn-danger' : 'btn-primary'"
          >
            <i class="feather icon-arrow-left arrow-icon"></i>
          </button>
          <div class="ml-1 text-capitalize text-dark goback-text">
            {{ $t("actions.go_back") }}
          </div>
        </div>
        <div :class="showFilters ? 'mx-2' : 'mx-0'">
          <EmailPreview :evaluationId="currentEvaluationId" :showFilters="showFilters" />
        </div>
      </div>
    </Transition>

    <b-modal
      id="import_file"
      :title="`${$t('messages.import.title')}`"
      no-close-on-esc
      no-close-on-backdrop
      ref="modalImport"
    >
      <vue-dropzone
        id="dropzone_file"
        ref="dropzoneFile"
        :options="dropzoneOptions"
        class="dropzone-file"
        @vdropzone-file-added="addImportFile"
        @vdropzone-removed-file="removeImportFile"
      />
      <div v-if="importMessages.length > 0" class="mt-2 scroll">
        <span v-for="(message, index) in importMessages" :key="index">
          <p class="text-danger mb-0" v-for="(error, index) in message" :key="index">
            {{ error }}
          </p>
        </span>
      </div>
      <template #modal-footer>
        <a :href="import_example_url" download>{{
          $t("messages.import.example_file")
        }}</a>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('import_file')"
          :disabled="loadingImport"
        >
          {{ $t("actions.cancel") }}
        </b-button>
        <b-button variant="primary" @click="importExcel" :disabled="loadingImport">
          {{ $t("actions.accept") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  ref,
  computed,
  watch,
  nextTick,
  onUnmounted,
  onMounted,
} from "@vue/composition-api";
import vSelect from "vue-select";
import useList from "./useList";
import { useToast } from "vue-toastification/composition";
import Pagination from "@/components/Pagination.vue";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import FilterModal from "@/components/Filters/FilterModal.vue";
import ButtonFilters from "@/components/Filters/ButtonFilters.vue";
import ToggleClearFilter from "@/components/Filters/ToggleClearFilter.vue";
import EvaluationForm from "@/components/operationalSecurity/EvaluationForm.vue";
import Filters from "./Filters.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import EmailPreview from "./EmailPreview.vue";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import axios from "@axios";
import store from "@/store";
import FiltersRow from "./FiltersRow.vue";
import { EventBus } from "@/libs/event-bus";
import vue2Dropzone from "vue2-dropzone";
import AssignTaskModal from "@/views/unit/AssignTaskModal.vue";
import {
  BAU_COMPLEMENTS_QUERY_KEY,
  BAU_COMPLEMENTS_UNIT_QUERY_VALUE,
  hasBauComplementsQueryFlag,
} from "@/utils/bauFormQuery";

const BAU_COMPLEMENT_TEMPLATE_NAME = "Visitas Inmuebles";

const normalizeText = (text = "") =>
  text
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

const getTemplateIdentifierByName = ({ templateOptions, templateName }) => {
  const normalizedTemplateName = normalizeText(templateName);
  const template = templateOptions.find(
    ({ name }) => normalizeText(name) === normalizedTemplateName
  );
  if (!template) {
    return null;
  }

  return template.id;
};

export default {
  name: "OperationalSecurityEvaluations",
  components: {
    Pagination,
    vSelect,
    BreadcrumbMenu,
    FilterModal,
    ButtonFilters,
    ToggleClearFilter,
    EvaluationForm,
    Filters,
    EmailPreview,
    FiltersRow,
    AssignTaskModal,
    vueDropzone: vue2Dropzone,
  },
  props: {
    showFilters: {
      type: Boolean,
      default: true,
    },
    slotId: {
      type: String,
      default: "main",
      required: false,
    },
    autoCreate: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    // For BAU Form
    const isBauComplementsMode = computed(() =>
      hasBauComplementsQueryFlag(context.root.$route?.query || {})
    );

    const {
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      templateOptions,
      templateFilter,
      sectorFilter,
      regionFilter,
      filtersCount,
      currentEvaluationId,
      currentEvaluation,
      isCreateRegistration,
      showEvaluationForm,
      showFormEmailPreview,
      isCreateSpecialForms,
      idFormAnswerOwner,
      unitOptions,
      unitFilter,
      userOptions,
      fetchUsers,
      userFilter,
      fromFilter,
      toFilter,
      statusOptions,
      statusFilter,
      currentSpecialForm,
      currentDataToReplace,
      hasNavigationHistory,
      openFromUrlParam,
      currentUrlParam,
      relatedTemplates,
      fetchList,
      refetchData,
      clearSearchFilters,
      buildFilters,
      updatePagination,
      openEvaluationModal,
      openEditEvaluationModal,
      goBackToList,
      openFormEmailPreview,
      openCreateNewFormType,
      isInProgressStatus,
      deleteBauComplementFromRow,
      sendForm,
      isFilterPanelOpen,
      applyFilters,
      handleNavigateToForm,
      validateIfUrlHasParams,
      formTemplateOptionsForAssignTask,
    } = useList(props);

    //COMPOSABLES
    const toast = useToast();
    const { t } = useI18nUtils();

    onMounted(() => {
      EventBus.on(`operational_security_reload_forms_and_list`, (params) => {
        refetchData();
      });
      validateIfUrlHasParams();
      // Launch the creation of a new evaluation form hotkey
      if (props.autoCreate) {
        openEvaluationModalWithContext();
      }
    });

    onUnmounted(() => {
      EventBus.off(`operational_security_reload_forms_and_list`);
    });

    //DATA
    const dropzoneImportFile = ref(null);

    const dropzoneOptions = ref({
      url: "https://httpbin.org/post",
      paramName: "file",
      autoProcessQueue: false,
      addRemoveLinks: true,
      dictRemoveFile: t("actions.delete"),
      acceptedFiles: ".xlsx,.xls",
      maxFilesize: 10,
      dictDefaultMessage: t("messages.import.select_file") + " (.xlsx .xls)",
    });

    const loadingImport = ref(false);

    const importMessages = ref([]);

    const modalImport = ref(null);

    //COMPUTED
    const startFormTemplateIdRef = ref(null);
    const requiresPrefillRef = ref(false);
    const initialUnitRef = ref(null);

    const fetchBauTemplateIdentifier = async () => {
      try {
        const response = await axios.get("/v1/operational-security-forms/templates", {
          params: { max: 200 },
        });
        return getTemplateIdentifierByName({
          templateOptions: response?.data?.data || [],
          templateName: BAU_COMPLEMENT_TEMPLATE_NAME,
        });
      } catch {
        return null;
      }
    };

    const resolveInitialTemplateIdForCreation = async () => {
      if (!isBauComplementsMode.value) {
        return null;
      }

      if (templateFilter.value) {
        return templateFilter.value;
      }

      const templateIdFromOptions = getTemplateIdentifierByName({
        templateOptions: templateOptions.value,
        templateName: BAU_COMPLEMENT_TEMPLATE_NAME,
      });
      if (templateIdFromOptions) {
        return templateIdFromOptions;
      }

      return fetchBauTemplateIdentifier();
    };

    const setCreationTemplateContext = (templateId) => {
      startFormTemplateIdRef.value = templateId;
      if (!templateId) {
        currentUrlParam.value = null;
        openFromUrlParam.value = false;
        return;
      }

      currentUrlParam.value = { name: "template", value: templateId };
      openFromUrlParam.value = true;
      setTimeout(() => {
        openFromUrlParam.value = false;
      }, 2000);
    };

    const normalizeBauComplementsQueryForCreation = async () => {
      const currentQuery = { ...(context.root.$route?.query || {}) };
      if (currentQuery[BAU_COMPLEMENTS_QUERY_KEY] !== BAU_COMPLEMENTS_UNIT_QUERY_VALUE) return;
      const nextQuery = {
        ...currentQuery,
        [BAU_COMPLEMENTS_QUERY_KEY]: "",
      };
      await context.root.$router.replace({ query: nextQuery }).catch(() => {});
    };

    const openEvaluationModalWithContext = async () => {
      await normalizeBauComplementsQueryForCreation();
      const templateId = await resolveInitialTemplateIdForCreation();
      setCreationTemplateContext(templateId);
      openEvaluationModal();
    };

    watch(
      () => {
        const query = context.root.$route && context.root.$route.query;
        if (!query) return null;
        return query["form-id"] ?? query.startForm ?? null;
      },
      async (createFormId) => {
        if (!createFormId) return;
        const id = Number(createFormId);
        if (!id) return;
        startFormTemplateIdRef.value = id;

        const query = { ...(context.root.$route.query || {}) };
        requiresPrefillRef.value = query.requiresPrefill === "true";
        if (query.unitId) {
          let unitData = store.getters["unit/getItemById"](query.unitId);
          if (!unitData) {
            try {
              const response = await store.dispatch("unit/get", query.unitId);
              unitData = response?.data || response || { id: Number(query.unitId) };
            } catch {
              unitData = { id: Number(query.unitId) };
            }
          }
          initialUnitRef.value = unitData;
        }

        if (query["owner-form"]) {
          currentSpecialForm.value = true;
          idFormAnswerOwner.value = Number(query["owner-form"]);
        }

        openEvaluationModal();
        nextTick().then(() => {
          const cleanQuery = { ...(context.root.$route.query || {}) };
          delete cleanQuery["form-id"];
          delete cleanQuery["owner-form"];
          delete cleanQuery.startForm;
          delete cleanQuery.requiresPrefill;
          delete cleanQuery.unitId;
          context.root.$router.replace({ query: cleanQuery }).catch(() => {});
        });
      },
      { immediate: true }
    );

    watch(
      () =>
        context.root.$route &&
        context.root.$route.query &&
        context.root.$route.query.specialForm,
      (specialFormName) => {
        if (!specialFormName) return;
        const query = { ...(context.root.$route.query || {}) };
        requiresPrefillRef.value = query.requiresPrefill === "true";
        isCreateSpecialForms.value = true;
        currentSpecialForm.value = specialFormName;
        showEvaluationForm.value = true;

        // Read unit from the unit store by ID
        if (query.unitId) {
          const unitFromStore = store.getters["unit/getItemById"](query.unitId);
          initialUnitRef.value = unitFromStore || { id: Number(query.unitId) };
        }

        nextTick().then(() => {
          delete query.specialForm;
          delete query.requiresPrefill;
          delete query.unitId;
          context.root.$router.replace({ query }).catch(() => {});
        });
      },
      { immediate: true }
    );

    watch(
      () => {
        const query = context.root.$route && context.root.$route.query;
        if (!query) return null;
        return query["open-id"] ?? query.id ?? null;
      },
      async (openId) => {
        if (!openId) return;
        const id = Number(openId);
        if (!id) return;
        try {
          const response = await axios.get(
            `v1/operational-security-forms/template-answers/${id}`
          );
          const formData = response.data;
          if (formData && formData.id) {
            openEditEvaluationModal(formData);
          }
        } catch (error) {
          toast({
            component: ToastificationContent,
            props: {
              title: error.response?.data?.message || t("messages.error.server_error"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        } finally {
          const query = { ...(context.root.$route.query || {}) };
          delete query["open-id"];
          delete query.id;
          context.root.$router.replace({ query }).catch(() => {});
        }
      },
      { immediate: true }
    );

    watch(showEvaluationForm, (isShown) => {
      if (!isShown) {
        startFormTemplateIdRef.value = null;
        requiresPrefillRef.value = false;
        initialUnitRef.value = null;
      }
    });

    const selectedFormAnswerForTask = ref(null);

    const openAssignTaskModal = (formAnswerItem) => {
      selectedFormAnswerForTask.value = formAnswerItem;
      context.root.$bvModal.show("assign-task-form-modal");
    };

    const openAssignTaskModalFromToolbar = () => {
      selectedFormAnswerForTask.value = null;
      context.root.$bvModal.show("assign-task-form-modal");
    };

    const handleTaskAssigned = () => {
      context.root.$bvModal.hide("assign-task-form-modal");
      refetchData();
    };

    const isDark = computed(() => store.state.appConfig.layout.skin === "dark");
    const deleteDialogTranslations = {
      title: context.root.$t("messages.delete.title"),
      body: context.root.$t("messages.delete.body"),
      confirm: context.root.$t("actions.delete"),
      cancel: context.root.$t("actions.cancel"),
    };

    //METHODS
    const checkExport = () => {
      // if (!templateFilter.value) {
      //   toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Sin plantilla seleccionada",
      //       icon: "AlertTriangleIcon",
      //       variant: "danger",
      //     },
      //   });

      //   return;
      // }

      (async () => await exportExcel())();
    };

    const getStatusVariant = (status) => {
      if (!status) return "secondary";
      const statusVariants = {
        in_progress: "primary",
        pending: "warning",
        review: "info",
        completed: "success",
        rejected: "danger",
        reopened: "primary",
      };
      return statusVariants[status] || "secondary";
    };

    const getStatusLabel = (status) => {
      return t(`operational_security.evaluation.status.${status ?? "in_progress"}`);
    };

    const confirmDeleteBauComplement = (item) => {
      context.root
        .$swal({
          title: deleteDialogTranslations.title,
          text: deleteDialogTranslations.body,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: deleteDialogTranslations.confirm,
          cancelButtonText: deleteDialogTranslations.cancel,
          customClass: {
            confirmButton: "btn btn-primary text-capitalize",
            cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
          },
          buttonsStyling: false,
        })
        .then((result) => {
          if (!result.value) return;
          deleteBauComplementFromRow(item);
        });
    };

    const donwloadPdf = async (item) => {
      try {
        const responseType = "blob";
        const axiosUrl = `/v1/operational-security-forms/download-pdf/${item.id}`;

        const response = await axios.get(axiosUrl, {
          responseType,
        });

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf",
          })
        );

        const link = document.createElement("a");
        let filename = response.headers["content-disposition"].split("filename=")[1];
        filename = filename.replace(/"/g, "");

        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        const notification = {
          id: filename,
          progress: 100,
          completed: true,
          view: "users",
          url: url,
          download: filename,
          title: "PDF Form. Seguridad operativa",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };

        store.dispatch("grid/updateDownloadNotification", notification);
      } catch (error) {
        const { statusText } = error.response;

        toast({
          component: ToastificationContent,
          props: {
            title: statusText,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    };

    const exportExcel = async () => {
      try {
        const responseType = "blob";

        const trimmedSearchQuery = String(searchQuery.value || "").trim();

        const params = {
          id_template: templateFilter.value,
          facility: unitFilter.value,
          user: userFilter.value,
          status: statusFilter.value,
          from: fromFilter.value,
          to: toFilter.value,
          ...(trimmedSearchQuery ? { q: trimmedSearchQuery } : {}),
        };

        const response = await axios.get(
          "v1/operational-security-forms/export/export-form-answers",
          {
            params,
            responseType,
          }
        );

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );

        const filename = response.headers["content-disposition"].split("filename=")[1];

        const link = document.createElement("a");

        link.href = url;

        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();

        const notification = {
          id: filename,
          progress: 100,
          completed: true,
          view: "users",
          url: url,
          download: filename,
          title: "Reporte Forms. Seguridad operativa",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };

        store.dispatch("grid/updateDownloadNotification", notification);
      } catch (error) {
        const { statusText } = error.response;

        toast({
          component: ToastificationContent,
          props: {
            title: statusText,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    };

    const addImportFile = (file) => {
      importMessages.value = [];
      dropzoneImportFile.value = file;
    };

    const removeImportFile = () => {
      dropzoneImportFile.value = null;
    };

    const importExcel = async () => {
      if (dropzoneImportFile.value == null) return;

      const formData = new FormData();

      formData.append("file", dropzoneImportFile.value);

      loadingImport.value = true;

      await axios
        .post("v1/operational-security-forms/import/import-form-answers", formData)
        .then((response) => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });

          dropzoneImportFile.value = null;
          modalImport.value.hide();
          refetchData();
        })
        .catch((error) => {
          //toast.clear(toastImportRems.value);

          toast({
            component: ToastificationContent,
            props: {
              title: "Error al iniciar la importación",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          loadingImport.value = false;
        });
    };

    return {
      isBauComplementsMode,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      templateOptions,
      templateFilter,
      sectorFilter,
      regionFilter,
      filtersCount,
      currentEvaluationId,
      currentEvaluation,
      isCreateRegistration,
      showEvaluationForm,
      isDark,
      showFormEmailPreview,
      isCreateSpecialForms,
      idFormAnswerOwner,
      unitOptions,
      unitFilter,
      userOptions,
      userFilter,
      fromFilter,
      toFilter,
      statusOptions,
      statusFilter,
      currentSpecialForm,
      currentDataToReplace,
      openFromUrlParam,
      currentUrlParam,
      relatedTemplates,
      hasNavigationHistory,
      refetchData,
      updatePagination,
      fetchList,
      buildFilters,
      clearSearchFilters,
      openEvaluationModal,
      openEvaluationModalWithContext,
      openEditEvaluationModal,
      goBackToList,
      checkExport,
      exportExcel,
      getStatusVariant,
      getStatusLabel,
      openFormEmailPreview,
      openCreateNewFormType,
      isInProgressStatus,
      confirmDeleteBauComplement,
      deleteBauComplementFromRow,
      sendForm,
      donwloadPdf,
      isFilterPanelOpen,
      applyFilters,
      handleNavigateToForm,
      startFormTemplateIdRef,
      requiresPrefillRef,
      initialUnitRef,
      selectedFormAnswerForTask,
      formTemplateOptionsForAssignTask,
      openAssignTaskModal,
      openAssignTaskModalFromToolbar,
      handleTaskAssigned,
      fetchUsers,
      dropzoneOptions,
      addImportFile,
      removeImportFile,
      import_example_url: `${window.__env.VUE_APP_BASE_URL}/import_examples/import_operational_security_form.xlsx`,
      loadingImport,
      importExcel,
      importMessages,
      modalImport,
    };
  },
};
</script>
<style lang="scss" scoped>
.badge-inline {
  display: inline;
}
.evaluation-index-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
}

.slide-right-left-enter-active,
.slide-right-left-leave-active {
  transition: transform 0.2s ease;
}

.slide-right-left-enter-from {
  transform: translateX(100%);
}

.slide-right-left-enter-to {
  transform: translateX(0%);
}

.slide-right-left-leave-from {
  transform: translateX(0%);
}

.slide-right-left-leave-to {
  transform: translateX(100%);
}

.slide-left-right-enter-active,
.slide-left-right-leave-active {
  transition: transform 0.2s ease;
}

.slide-left-right-enter-from {
  transform: translateX(-100%);
}

.slide-left-right-enter-to {
  transform: translateX(0%);
}

.slide-left-right-leave-from {
  transform: translateX(0%);
}

.slide-left-right-leave-to {
  transform: translateX(-100%);
}

.cursor-pointer {
  cursor: pointer;
}

.goback-text {
  font-weight: 600;
}

.arrow-icon {
  font-size: 16px;
}

.card {
  box-shadow: none !important;
}

.filters-panel-fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 10;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 0;
}

.filters-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 0;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.filters-panel-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 1.5rem;

  // Estilos para el scrollbar
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

.buttonFilter {
  height: 32px;
}

.filters-panel-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  flex-shrink: 0;
}
</style>

<style lang="scss">
.custom-sticky-wrapper {
  .table.b-table {
    thead {
      position: sticky !important;
      top: 0 !important;
      z-index: 10 !important;
    }
  }
}

.dark-layout {
  .filters-panel-fullscreen {
    background-color: #283046;
    color: #b4b7bd;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }

  .evaluation-index-container {
    background-color: var(--third-dark);
  }

  .filters-panel-header {
    border-bottom-color: rgba(255, 255, 255, 0.758);
  }

  .filters-panel-footer {
    border-top-color: #3b4253;
  }

  .filters-panel-content {
    &::-webkit-scrollbar-track {
      background: #161d31;
    }

    &::-webkit-scrollbar-thumb {
      background: #555;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #777;
    }
  }
}
</style>
